const storeName = 'CART';

export default {
    SET_LOADING: `${storeName}.SET_LOADING`,
    LOAD_CART_DATA: `${storeName}.LOAD_CART_DATA`,
    MERGE_CART: `${storeName}.MERGE_CART`,
    SET_CART_DATA: `${storeName}.SET_CART_DATA`,
    SET_GUID: `${storeName}.SET_GUID`,
    SET_CODE: `${storeName}.SET_CODE`,
    SET_EGIFT_CART_ID: `${storeName}.SET_EGIFT_CART_ID`,
    SET_EGIFT_CARD_CODE: `${storeName}.SET_EGIFT_CARD_CODE`,
    ADD_TO_CART: `${storeName}.ADD_TO_CART`,
    ADD_OR_UPDATE_CART: `${storeName}.ADD_OR_UPDATE_CART`,
    REMOVE_FROM_CART: `${storeName}.REMOVE_FROM_CART`,
    REMOVE_ALL_CART_ENTRIES: `${storeName}.REMOVE_ALL_CART_ENTRIES`,
    UPDATE_CART: `${storeName}.UPDATE_CART`,
    UPDATE_CART_COMPLETE: `${storeName}.UPDATE_CART_COMPLETE`,
    SET_HAS_LOW_STOCK: `${storeName}.SET_HAS_LOW_STOCK`,
    SET_EMAIL_ADDRESS: `${storeName}.SET_EMAIL_ADDRESS`,
    SET_DATA_ATTR: `${storeName}.SET_DATA_ATTR`,
    STORAGE_GUID: `${storeName}.GUID`,
    STORAGE_CODE: `${storeName}.CODE`,
    INITIALIZE: `${storeName}.INITIALIZE`,
    CHECK_REDIRECT: `${storeName}.CHECK_REDIRECT`,
    FORCE_CART_CODE_CHANGE: `${storeName}.FORCE_CART_CODE_CHANGE`,
    CART_BEEN_MERGED: `${storeName}.CART_BEEN_MERGED`,
    FORCE_OUT_OF_STOCK: `${storeName}.FORCE_OUT_OF_STOCK`,
    STOCK_LEVEL_LIST: `${storeName}.STOCK_LEVEL_LIST`,
    ADJUST_CART: `${storeName}.ADJUST_CART`,
    LIMITATIVE_BRANDS: `${storeName}.LIMITATIVE_BRANDS`,
    SET_LIMITATIVE_BRANDS: `${storeName}.SET_LIMITATIVE_BRANDS`,
    RESET_LIMITATIVE_BRANDS: `${storeName}.RESET_LIMITATIVE_BRANDS`,
    CHECK_LIMITATIVE_BRANDS: `${storeName}.CHECK_LIMITATIVE_BRANDS`,
    LOAD_OVERLIMITED_BRANDS: `${storeName}.LOAD_OVERLIMITED_BRANDS`,
    SET_OVERLIMITED_BRANDS: `${storeName}.SET_OVERLIMITED_BRANDS`,
    SET_HAVE_OUT_OF_STOCK: `${storeName}.SET_HAVE_OUT_OF_STOCK`,
    SET_OUT_OF_STOCK_ENTRIES_NUMBER: `${storeName}.SET_OUT_OF_STOCK_ENTRIES_NUMBER`,
    EXPRESS_PICKUP_VALIDATION: `${storeName}.EXPRESS_PICKUP_VALIDATION`,
    DELETE_STOCK_LEVEL_LIST: `${storeName}.DELETE_STOCK_LEVEL_LIST`,
    SET_STOCK_VALIDATION: `${storeName}.SET_STOCK_VALIDATION`,
    REMOVE_ITEM_COMPLETE: `${storeName}.REMOVE_ITEM_COMPLETE`,
    REMOVE_ITEM_RESET: `${storeName}.REMOVE_ITEM_RESET`,
    CLEAR_DELIVERY_ADRESS: `${storeName}.CLEAR_DELIVERY_ADRESS`,
    CLEAR_HAS_LOW_STOCK: `${storeName}.CLEAR_HAS_LOW_STOCK`,
    SET_LOW_STOCK_ITEMS: `${storeName}.SET_LOW_STOCK_ITEMS`,
    REMOVE_FROM_LOW_STOCK_ITEMS: `${storeName}.REMOVE_FROM_LOW_STOCK_ITEMS`,
    CHECK_ADDRESSES: `${storeName}.CHECK_ADDRESSES`,
    CHECK_ADDRESSES_COMPLETE: `${storeName}.CHECK_ADDRESSES_COMPLETE`,
    SET_ADJUSTED_CART_DATA: `${storeName}.SET_ADJUSTED_CART_DATA`,
    RESET_ADJUSTED_CART_DATA: `${storeName}.RESET_ADJUSTED_CART_DATA`,
    SET_IS_PRODUCTS_BEEN_MERGED: `${storeName}.SET_IS_PRODUCTS_BEEN_MERGED`,
    TOGGLE_VOUCHER_ON_CART: `${storeName}.TOGGLE_VOUCHER_ON_CART`,
    CHECK_EGIFTCARD_CART: `${storeName}.CHECK_EGIFTCARD_CART`,
    RESTORE_REGULAR_CART: `${storeName}.RESTORE_REGULAR_CART`,
    SET_EGIFTCARD_CART_ACTIVE: `${storeName}.SET_EGIFTCARD_CART_ACTIVE`,
    SET_REGULAR_CART_ID: `${storeName}.SET_REGULAR_CART_ID`,
    SET_LOADED: `${storeName}.SET_LOADED`,
    PERSIST_GWP_PRODUCT_CODES: `${storeName}.PERSIST_GWP_PRODUCT_CODES`,
    SELECT_GWP: `${storeName}.SELECT_GWP`,
    UPDATE_SELECTED_GWP_ITEM: `${storeName}.UPDATE_SELECTED_GWP_ITEM`,
    CHECK_RTS_AVAILABILITY: `${storeName}.CHECK_RTS_AVAILABILITY`,
    VOUCHER_IS_LOADING: `${storeName}.VOUCHER_IS_LOADING`,
    LOAD_HOME_DELIVERY_DATE: `${storeName}.LOAD_HOME_DELIVERY_DATE`,
    LOAD_CLICK_AND_COLLECT_DELIVERY_DATE: `${storeName}.LOAD_CLICK_AND_COLLECT_DELIVERY_DATE`,
    LOAD_CLICK_AND_COLLECT_EXPRESS_DELIVERY_DATE: `${storeName}.LOAD_CLICK_AND_COLLECT_EXPRESS_DELIVERY_DATE`,
    LOAD_POST_POINT_DELIVERY_DATE: `${storeName}.LOAD_POST_POINT_DELIVERY_DATE`,
    SET_HOME_DELIVERY_DATE: `${storeName}.SET_HOME_DELIVERY_ESTIMATED_DATE`,
    SET_CLICK_AND_COLLECT_EXPRESS_DELIVERY_DATE: `${storeName}.SET_CLICK_AND_COLLECT_DELIVERY_ESTIMATED_DATE`,
    SET_CLICK_AND_COLLECT_TRADITIONAL_DELIVERY_DATE: `${storeName}.SET_CLICK_AND_COLLECT_TRADITIONAL_DELIVERY_ESTIMATED_DATE`,
    SET_POST_POINT_DELIVERY_DATE: `${storeName}.SET_POST_POINT_DELIVERY_DATE`,
    REMOVE_BILLING_ADDRESS: `${storeName}.REMOVE_BILLING_ADDRESS`,
    REMOVE_BILLING_ADDRESS_SUCCESS: `${storeName}.REMOVE_BILLING_ADDRESS_SUCCESS`,
    SET_TEMPORARY_ADDRESS: `${storeName}.SET_TEMPORARY_ADDRESS`,
    SET_ADD_TO_CART_ERROR: `${storeName}.SET_ADD_TO_CART_ERROR`,
    SET_REMOVE_FROM_CART_ERROR: `${storeName}.SET_REMOVE_FROM_CART_ERROR`,
    SET_DELIVERY_ADDRESS: `${storeName}.SET_DELIVERY_ADDRESS`,
    SET_PAYMENT_ADDRESS: `${storeName}.SET_PAYMENT_ADDRESS`,
    CHECK_FORBIDDEN_ENTRIES_IN_STOCK: `${storeName}.CHECK_FORBIDDEN_ENTRIES_IN_STOCK`,
    SET_LOYALTY_CHEQUES_MESSAGE: `${storeName}.SET_LOYALTY_CHEQUES_MESSAGE`,
    OPEN_SWIPE_TO_BUY_DIALOG: `${storeName}.OPEN_SWIPE_TO_BUY_DIALOG`,
    CLOSE_SWIPE_TO_BUY_DIALOG: `${storeName}.CLOSE_SWIPE_TO_BUY_DIALOG`,
    SWIPE_TO_BUY_PLACE_ORDER: `${storeName}.SWIPE_TO_BUY_PLACE_ORDER`,
    DELETE_CART: `${storeName}.DELETE_CART`,
    RESTORE_OLD_CART: `${storeName}.RESTORE_OLD_CART`,
    MANAGE_POST_PROCESS_FOR_SWIPE_TO_BUY: `${storeName}.MANAGE_POST_PROCESS_FOR_SWIPE_TO_BUY`,
    CREATE_CART: `${storeName}.CREATE_CART`,
    BULK_ADD_TO_CART: `${storeName}.BULK_ADD_TO_CART`,
    DELETE_CART_COMPLETE: `${storeName}.DELETE_CART_COMPLETE`,
    SWIPE_TO_BUY_REDIRECT: `${storeName}.SWIPE_TO_BUY_REDIRECT`,
    SWIPE_TO_BUY_CLOSE_PROCESSED: `${storeName}.SWIPE_TO_BUY_CLOSE_PROCESSED`,
    REQUEST_BUNDLE_REFERENCES: `${storeName}.REQUEST_BUNDLE_REFERENCES`,
    SET_MAX_ALLOWED_PRODUCT_EXCEEDED: `${storeName}.SET_MAX_ALLOWED_PRODUCT_EXCEEDED`,
};
